import '../../css/report-card.css';
import React, {useState, useEffect, useRef} from "react";
import { CircularProgress } from '@mui/material';
import { Box, Card, CardContent, Chip, Container, Grid, Paper, 
  MenuItem, Select, Tooltip, Typography } from '@mui/material';
import moment from 'moment';

import { AppHelper } from '../../AppHelper';
import AppTopBar from '../common/app-top-bar';
import IconButton from '@mui/material/IconButton';
import InfoIcon from "@mui/icons-material/Info";
import { useExerciseContext } from "../../contexts/context-exercise";
import ReportCardChart from "./report-card-chart";
const dayjs = require('dayjs');

export default function ReportCardExercise() {
  const [oUser, setOUser] = useState(AppHelper.userCacheGet());
  
  const [loading, setLoading] = useState(false);
  const refTopBar = useRef(null);
  const [chartData, setChartData] = useState(null);
  const [chartDataPolar, setChartDataPolar] = useState(null);
  const {recList, setRecList } = useExerciseContext();
  const [exerciseListForReport, setExerciseListForReport] = useState(null);
  const [bestExercise, setBestExercise] = useState(null);
  const [profileName, setProfileName] = useState('');
  const todayTitle = moment().format(`DD MMM 'YY`);
  const [profiles, setProfiles] = React.useState([]);
  const [profileId, setProfileId] = useState('');

  const chipSampleColors = {
    '1': 'rgba(19,130,117,1)',
    '0': 'white'
  };

  useEffect(() => {
    AppHelper.apiAuditPost("P-RC", "");
  }, []);
  useEffect(() => {
    if(oUser) setProfileName(oUser.name);
  }, [oUser]);
  useEffect(() => {
    if(!recList || recList.length==0) {
        return;
    }
    setExerciseListForReport(recList);
    var _user = AppHelper.userCacheGet();
    if (_user && _user.grade) {
      setProfileId(_user.profileId);
      fetchProfiles(_user);
    }
    if(!oUser && oUser.token && (!recList || recList.length==0)) {
        return;
    }
    setExerciseListForReport(recList);
  }, [recList]);

  useEffect(()=>{
    if(!exerciseListForReport) return;
    fetchScores();
  }, [exerciseListForReport]);
    
  
  const fetchScores = async () => {
    try {
		  setLoading(true);
      var _iReport = 0;
      var _recExercise = [];
      var _chartData = [];
      var _exerciseArr = AppHelper.sortList(exerciseListForReport, 'tCode', 2);
      var _top7 = _exerciseArr.filter(x=>!x.isSample);
      var availableExCount = _top7.length;
      var maxCount = 0;
      if (availableExCount < 7){
        maxCount = availableExCount;
      } else {
        maxCount = 7;
      }
      var _bestExercise = {score: 0, exName:'', title: '', time: '', avgScore: 0, essayCount: 0};
      var _sumScore = 0;
      for(var i=0; i<maxCount; i++)
      {
          var _r = _top7[i];
          const _resExcDetail = await AppHelper.apiPost('api/exercise/sentenceTransform/get', {token: oUser.token, profileId, exerciseId: _r.exerciseId});

          if (_resExcDetail && _resExcDetail.status) {
            _recExercise.push(_resExcDetail.data);
            var _recScore = (_resExcDetail.data.questionYCount/_resExcDetail.data.questionCount)*100;
            if (_resExcDetail.data.questionYCount == 0 && _resExcDetail.data.questionCount == 0) {
                _recScore = 0;
            }
            if(_recScore>_bestExercise.score){
                _bestExercise = {score: _recScore, exCount: _top7.length-i, exName: _r.questionSetName, time: _r.tTitle, avgScore: 0, essayCount: 0 };
            }
            _sumScore += _recScore;
            _chartData.push({
                title: _top7.length-i,
                score: _recScore,
                time: _r.tTitle,
                tCode: _r.tCode,
            });
            if(i==0){
                setChartDataPolar(_recScore);
            } else {
            }
          }
      }
      if(i<1){
      }
      _bestExercise.exerciseCount = i;// _top7.length;
      _bestExercise.avgScore = _sumScore == 0 ? 0 : Math.round(_sumScore/i);
      setBestExercise(_bestExercise);

      setChartData(_chartData.reverse());
      
      _recExercise.forEach(r => {
      });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching score:', error);
    } finally {
		  setLoading(false); 
		}
  };

  const fetchExerciseList = async(argProfileId)=>{
    setLoading(true);
    var _user = AppHelper.userCacheGet();
    if (!_user) return;
    var _res = await AppHelper.apiPost('api/exercise/sentenceTransform/list', {token: _user.token, profileId: argProfileId});
    if(!_res.status){
      return;
    }
    var _arr = [..._res.data];
    _arr.forEach(x=>{
      x.time = dayjs(x.timestampUtc).format("DD MMM YY' hh:mm A");
      x.tTitle = dayjs(x.timestampUtc).format("DD MMM YY' hh:mm A");
      x.tCode = dayjs(x.timestampUtc).format("YYYYMMDDHHmmss");
    });
    _arr = AppHelper.sortList(_arr, 'tCode', 2);
    setExerciseListForReport(_arr);
    setLoading(false);
  }
  const fetchProfiles = async () => {
    if (!oUser) return;
    try {
    const response = await AppHelper.apiPost('api/profile-linked/list', { token: oUser.token });
        if (response && response.status && response.data) {
        setProfiles(response.data);
        } else {
        throw new Error('Failed to fetch profiles');
        }
    } catch (error) {
        console.error('Error fetching profiles:', error);
    }
};
  const profileSelect = async (arg) => {
    var _profile = profiles.find(x=>x.profileId == arg.target.value);
    if(!_profile) return;
    setProfileName(_profile.name);
    setProfileId(arg.target.value);
    fetchExerciseList(arg.target.value);
  }

  return (
  <div>
    <AppTopBar ref={refTopBar}/>
    {setRecList &&
    <Grid container>
      <Grid item xs={12} textAlign={'right'}>
        {profiles && profiles.length > 1 && (
          <Select labelId='lblProfile'
            value={profileId}
            onChange={profileSelect}
            label=""
            sx={{ "& fieldset": { border: 'none' }}}
          >
            {profiles.map((item) => (
              <MenuItem key={item.profileId} value={item.profileId}>
                <Chip label={item.grade} variant="filled" style={{
                  backgroundColor: chipSampleColors[item.selected == '1' ? '0' : '1'],
                  color: chipSampleColors[item.selected == '1' ? '1' : '0'],
                  height: "20px",
                  marginRight: '5px',
                  marginTop: '-2px'
                }}
                sx={{ fontSize: '.8rem', marginTop: '0rem', marginBottom: '0', padding: '0.1px', maxHeight: "28px", }}
                />
                {item.isLinked === true ? (
                  <>
                  <Box marginTop="-3px">
                  <Typography component='span'>{item.name}</Typography>
                    <Chip label={'LINKED'} variant="filled" style={{
                      backgroundColor: "grey",
                      color: "white",
                      size: "small", 
                      height: "20px", 
                      marginLeft: '5px',
                      marginRight: '-5px', 
                      marginTop: '-2px'
                    }} />
                    <Tooltip sx={{marginRight: "-10px", marginTop: '-2px'}} title={`Linked from ${item.email}`}>
                      <IconButton>
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  </>
                ) : 
                `${item.name}`}
              </MenuItem>
            ))}
          </Select>
        )}
      </Grid>
    </Grid>
    }
    <Container component="main" maxWidth="sm" sx={{ mb: 0 }}>
      <Paper sx={{ 
        my: { 
          xs: 3, md: 5 }, p: { xs: 2, md: 3 }, minHeight:{md:'70vh', xs:'70vh'}, 
        }} elevation={3}>
          <Grid container>
            <Grid item xs={6}>
              <div style={{marginBottom:0, fontSize:'1.8rem', fontWeight:'bold'}}>Report Card</div>
            </Grid>
            <Grid item xs={6} display={'flex'} alignItems={'flex-end'} justifyContent={'flex-start'} flexDirection={'column'}>
              <div style={{fontSize:'2rem', color:'rgba(19,130,117,1)', fontWeight:700, fontFamily:'Roboto", "Helvetica", "Arial", sans-serif' }}>
              EssayAce
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <div style={{fontSize:'1rem', marginLeft:'.2rem'}}>
                {oUser &&
                <div style={{fontWeight:'bold', fontSize: "1.2rem"}}>{profileName}</div>
                }
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{fontSize:'1rem', textAlign:'right'}}>
                {todayTitle}
              </div>
            </Grid>
          </Grid>
          { loading &&
            <div style={{margin:'2rem', textAlign:'center'}}>
              <CircularProgress />
            </div>
          }
          { !loading &&
          <>
          { bestExercise &&
          <Grid container sx={{marginBottom:'1rem', marginTop:'1rem'}}>
            <Grid item xs={12} marginBottom={'.5rem'}>
              <Card>
                <CardContent>
                  <Grid container>
                    <Grid item xs={5}>
                      <Typography variant="h5" component="div" style={{fontWeight:'bold', color:'rgba(19,130,117,1)'}}>
                        {bestExercise.score}%
                      </Typography>
                    </Grid>
                    <Grid item xs={7} textAlign={'right'}>
                      <Typography variant="body2" color="text.primary" fontWeight={'normal'} style={{fontSize: '1.2rem'}}>
                        Best Exercise
                      </Typography>
                      <div style={{fontSize:'1rem'}}>
                        {bestExercise.time}
                      </div>
                    </Grid>
                  </Grid>
                  <div style={{fontSize: '1.2rem'}}>Exercise {bestExercise.exCount}</div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Grid container>
                    <Grid item xs={5}>
                      <Typography variant="h5" component="div" style={{fontWeight:'bold', color:'rgba(19,130,117,1)'}}>
                        {bestExercise.avgScore}%
                      </Typography>
                    </Grid>
                    <Grid item xs={7} textAlign={'right'}>
                      <Typography variant="body2" color="text.primary" style={{fontSize: '1.2rem'}}>
                        Avg. Score
                      </Typography>
                    </Grid>
                  </Grid>
                  <div style={{fontSize: '1.2rem'}}>Across {bestExercise.exerciseCount} exercise</div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          }
          <div>
            <ReportCardChart argData={chartData} />
          </div>
          </>
          }
      </Paper>
    </Container>
    <div style={{height:0}}>&nbsp;</div>
  </div>
  );
}
